import { getLabels } from '../labels';
export const AVAILABILITY_TOTAL_STEPS = 3;
const HIGH_RATIO_THRESHOLD = 2 / 3;
const MEDIUM_RATIO_THRESHOLD = 1 / 3;
const LEVEL_PRESENTATION = {
    high: {
        filledSteps: 3,
        fillClassName: 'bg-success',
        labelTranslationKey: 'high',
    },
    medium: {
        filledSteps: 2,
        fillClassName: 'bg-warning',
        labelTranslationKey: 'medium',
    },
    low: {
        filledSteps: 1,
        fillClassName: 'bg-danger',
        labelTranslationKey: 'low',
    },
    none: {
        filledSteps: 0,
        fillClassName: 'bg-fg-disabled',
        labelTranslationKey: 'none',
    },
};
const resolveLevel = (available, total) => {
    if (available <= 0 || total <= 0)
        return 'none';
    const ratio = available / total;
    if (ratio >= HIGH_RATIO_THRESHOLD)
        return 'high';
    if (ratio >= MEDIUM_RATIO_THRESHOLD)
        return 'medium';
    return 'low';
};
export function resolveAvailabilityStepsPresentation(available, total) {
    const { filledSteps, fillClassName, labelTranslationKey } = LEVEL_PRESENTATION[resolveLevel(available, total)];
    return { filledSteps, fillClassName, label: getLabels().parking_information.availability[labelTranslationKey] };
}
